<template>
  <el-dialog
    :title="dialogTitle"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="1000px"
    class="dialog_title dialog-style-1"
    @close="onClose"
    @closed="onClosed"
  >
    <ul class="public-images-list-2">
      <li class="images-list-item" v-for="(item, index) in imageList" :key="index">
        <el-image :src="item.savepath" :preview-src-list="imagePreview"> </el-image>
        <span
          class="images-choice"
          :class="item.checked ? 'images-choice-activity' : ''"
          @click="imagesChoice(index)"
        ></span>
      </li>
    </ul>
    <ComPagination
      :total="formData.total"
      @current-change="currentChange"
      @size-change="sizeChange"
      v-if="formData.total"
    ></ComPagination>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit()">确 定</el-button>
      <el-button @click="close()">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getApiClassImage } from "@/api/tearcher";
export default {
  data() {
    return {
      dialogVisible: false, //弹窗是否显示
      dialogTitle: "从班级圈获取", //弹窗标题
      //表单数据
      formData: {
        class_id: sessionStorage.getItem("class_id"),
        page: 1,
        limit: 20,
        total: 0,
      },
      imageList: [], //图片列表
      imagePreview: [], //图片预览
    };
  },
  methods: {
    //更新数据
    update(e) {
      this.$emit("update", e);
      this.dialogVisible = false;
    },
    //打开
    open() {
      this.dialogVisible = true;
      this.getClassImage();
    },
    //确定按钮
    submit() {
      if (this.imageList.length > 0) {
        let list = [];
        this.imageList.forEach((item) => {
          if (item.checked) {
            list.push({
              id: item.id,
              savename: item.savename,
              savepath: item.savepath,
            });
          }
        });
        this.update(list);
      }
    },
    //关闭按钮
    close() {
      this.dialogVisible = false;
    },
    //关闭回调
    onClose() {},
    //关闭结束回调
    onClosed() {
      this.formData.page = 1;
      this.formData.limit = 10;
      this.formData.total = 0;
      this.imageList = [];
    },
    //获取班级圈图片
    getClassImage() {
      getApiClassImage(this.formData).then((res) => {
        if (res.error_code == 200) {
          let list = res.data.data || [];
          if (list.length > 0) {
            list.forEach((item) => {
              item.checked = false;
            });
            this.imageList = list;
          }
          this.imagePreview = this.imageList.map((item) => {
            return item.savepath;
          });
          this.formData.total = res.data.total;
        }
      });
    },
    //选择图片
    imagesChoice(index) {
      this.imageList[index].checked = !this.imageList[index].checked;
    },
    //分页改变回调
    currentChange(page) {
      this.formData.page = page;
      this.getClassImage();
    },
    //分页页数改变回调
    sizeChange(limit) {
      this.formData.limit = limit;
      this.getClassImage();
    },
  },
  watch: {},
  created() {},
};
</script>

<style lang="less" scoped></style>
